import type {PurchaseEvent} from '@interfaces/Analytics';
import Analytics from '@services/analytics/Analytics';

export function sendRequiredPaymentEvents() {
    document.querySelectorAll('.js-event-payment-successful').forEach((item: HTMLDivElement) => {
        const props = JSON.parse(item.dataset.props ?? '') as PurchaseEvent;
        Analytics.triggerEventWithPayment(props);
    });
}
